import React from 'react';
import { Button } from '@blueprintjs/core';
import { Link } from 'react-router';
import { DropDownChonLoaiDonThu, DropDownChonNguonDon, DropDownTinhTrangGiaiQuyet, DropDownKetQuaGiaiQuyet} from 'components/tt-forms';
import { DatePicker, InputTuKhoa, Input } from 'components/tt-forms/common';
import { Checkbox } from '@blueprintjs/core';

let classNames = require('classnames');

class FormSearch extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tuKhoa: '',
      maDon: '',
      isSaveTemp: false,
      startDate: '',
      endDate: '',
      nguonDon: '',
      phanLoaiDon: '',
      tinhTrangXuLy: '',
      ketQuaXuLy: '',
      searching: this.props.disabled,
      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false
    };
  }

  componentDidMount() {
    let data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
    this.state.tuKhoa = data.tuKhoa || '';
    if (data.advanceSearch) {
      this.state.isSaveTemp = data.isSaveTemp;
      this.state.maDon = data.maDon || '';
      this.state.nguonDon = data.nguonDon || '';
      this.state.phanLoaiDon = data.phanLoaiDon || '';
      this.state.tinhTrangXuLy = data.trangThaiDonToanHT || '';
      this.state.ketQuaXuLy = data.ketQuaToanHT || '';
      this.state.startDate = data.tiepNhanTuNgay ? new Date(data.tiepNhanTuNgay) : '';
      this.state.endDate = data.tiepNhanDenNgay ? new Date(data.tiepNhanDenNgay) : '';
    }
  }

  handleSearch(e) {
    e.preventDefault();
    if (!this.props.advanceSearch) {
      this.setState({
        doSearch: true
      });
      this.props.handleSearch(this.state, e);
    } else {
      if(this.validateSubmitForm()) {
        this.setState({
          doSearch: true
        });
        this.props.handleSearch(this.state, e);
      }
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    // if (!this.refs.containerFileDinhKem.validate()) {
    //   pass = false;
    // }
    return pass;
  }

  componentWillUnmount() {

  }

  cancel(e) {
    this.props.onCancel(e);
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  handleChange(name, e) {
    if (name === "isSaveTemp") {
      this.setState({isSaveTemp: !this.state.isSaveTemp});
    } else {
      this.setState({[name]: e.target.value});
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      searching: nextProps.disabled,
      doSearch: nextProps.search
    });

    if (nextProps.resetForm) {
      this.resetData();
    }
  }

  resetData() {
    this.setState({
      tuKhoa: '',
      isSaveTemp: false,
      maDon: '',
      nguonDon: '',
      phanLoaiDon: '',
      startDate: '',
      endDate: '',

      tinhTrangXuLy: '',
      ketQuaXuLy: '',

      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false
    })
  }

  render() {
    let classes = ['btn-green', 'tt-search'];

    if (this.state.searching) {
      classes.push('btn-disable');
    }
    if (this.state.doSearch) {
      classes.push('btn-loading');
    }

    let classesInput = [];

    if (this.props.advanceSearch) {

      classesInput.push('input-20');
    } else {
      classesInput.push('input-show-group');
    }

    let inputClasses = classNames(classesInput);

    let btnClasses = classNames(classes);

    return (
      <form className="search-form" onSubmit={this.handleSearch.bind(this)}>
        {
          !this.props.searchEmail &&
          <InputTuKhoa
            onChange={this.handleChange.bind(this, 'tuKhoa')}
            value={this.state.tuKhoa}
            channel="formTaoDon" className={inputClasses} />
        }
        {
          this.props.searchEmail &&
          <InputTuKhoa
            label="Email người dùng"
            onChange={this.handleChange.bind(this, 'tenEmail')}
            value={this.state.tenEmail}
            channel="formTaoDon"
            require
            bindValidator={this}
            className={inputClasses}
            placeholder="Nhập email người dùng..."
          />
        }
        <DatePicker className="input-20" label='Tiếp nhận từ ngày' bindValidator={this} channel="formTaoDon" endDate={this.state.endDate} value={this.state.startDate} onChange={this.handleChangeDate.bind(this, 'startDate')} />
        <DatePicker className="input-20" label='Đến ngày' bindValidator={this} channel="formTaoDon" startDate={this.state.startDate} value={this.state.endDate} onChange={this.handleChangeDate.bind(this, 'endDate')} />
        <Input label="Mã đơn" placeholder="Nhập mã đơn..." value={this.state.maDon} onChange={this.handleChange.bind(this, 'maDon')} className="input-20" />
        <div className="btn-wrap-20">
          <Button className={btnClasses} text="Tìm kiếm" type="submit" disabled={this.state.searching ? 'disabled' : ''} />
        </div>
        <div className="clear-left">
          <DropDownChonNguonDon selectedValue={this.state.nguonDon} onChange={this.handleChange.bind(this, 'nguonDon')} className="input-20" />
        </div>
        <DropDownChonLoaiDonThu selectedValue={this.state.phanLoaiDon} onChange={this.handleChange.bind(this, 'phanLoaiDon')} className="input-20" />
        <DropDownTinhTrangGiaiQuyet label="Tình trạng xử lý" selectedValue={this.state.tinhTrangXuLy} className="input-20" onChange={this.handleChange.bind(this, 'tinhTrangXuLy')}/>
        <DropDownKetQuaGiaiQuyet label="Kết quả xử lý" selectedValue={this.state.ketQuaXuLy} className="input-20" onChange={this.handleChange.bind(this, 'ketQuaXuLy')}/>
        <div className="input-20">
          <Link className={this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search"} onClick={this.cancel.bind(this)}><i className="tt tt-delete"></i>Hủy tìm kiếm nâng cao</Link>
        </div>
        { this.props.onStatus === 'DANG_XU_LY' &&
          <div className="input-20 checkbox-luutam">
            <Checkbox className="pt-large" checked={this.state.isSaveTemp} onChange={this.handleChange.bind(this, 'isSaveTemp')} name="donLuuTam">
              <span>Đơn đã lưu tạm</span>
            </Checkbox>
          </div>
        }
      </form>
    );
  }
}

FormSearch.defaultProps = {
  validators: {},
  handleSearch: function () {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false
}

export default FormSearch;



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/list-handle-letters-search/FormSearch.jsx